module.exports = __webpack_public_path__ + "img/adorno2.08e32911.svg";